import {
  AssignedWorkAreaDto,
  WorkAreaDto,
  WorkAreaEquipmentBindingTypes,
} from '@operations/app/api'

export function updateWorkAreaEquipmentAssignments(
  workAreaOnThePage: WorkAreaDto,
  equipmentId: number,
  assignments: AssignedWorkAreaDto[],
) {
  // Try to find the equipment in the current work area
  const equipmentInWorkArea = workAreaOnThePage.workAreaEquipments.find(
    w => w.equipmentId === equipmentId,
  )

  if (equipmentInWorkArea) {
    // Find the assignment in the event for this equipment and work area
    const assignmentInEvent = assignments.find(x => x.workAreaId === equipmentInWorkArea.workAreaId)
    equipmentInWorkArea.assignmentType = assignmentInEvent
      ? assignmentInEvent.assignmentType
      : WorkAreaEquipmentBindingTypes.None
  } else {
    // If not present, check if the event assigns this equipment to the current work area
    const assignmentForThisWorkArea = assignments.find(a => a.workAreaId === workAreaOnThePage.id)
    if (assignmentForThisWorkArea) {
      workAreaOnThePage.workAreaEquipments.push({
        equipmentId,
        assignmentType: assignmentForThisWorkArea.assignmentType,
        workAreaId: workAreaOnThePage.id,
      })
    }
  }

  // Remove any equipment assignments with type None
  workAreaOnThePage.workAreaEquipments = workAreaOnThePage.workAreaEquipments.filter(
    w => w.assignmentType !== WorkAreaEquipmentBindingTypes.None,
  )
}
